import React, { useState } from "react";
import { createPortal } from "react-dom";
import api from "@/lib/api";
import { Modal } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";

/**
 * „Șterge definitiv" — doar pentru Admin. Se deschide un dialog care spune dacă ștergerea e posibilă:
 * o înregistrare cu date legate NU se poate șterge (apare ce o blochează); una fără dependențe se
 * șterge după ce Adminul scrie „șterge". entity: "post" | "employment" | "org-unit" | "user".
 */
export default function PurgeButton({ entity, id, onDone, style }) {
  const { has } = useAuth();
  const [info, setInfo] = useState(null);   // răspunsul GET /admin/purge/{entity}/{id}
  const [word, setWord] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (!has("data.purge")) return null;

  const open = async () => {
    setErr(""); setWord("");
    try { setInfo((await api.get(`/admin/purge/${entity}/${id}`)).data); }
    catch (e) { setInfo({ error: e?.response?.data?.detail || "Eroare" }); }
  };
  const close = () => { setInfo(null); setWord(""); setErr(""); };
  const doDelete = async () => {
    setBusy(true); setErr("");
    try { await api.delete(`/admin/purge/${entity}/${id}`, { data: { confirm: word } }); close(); onDone && onDone(); }
    catch (e) { setErr(e?.response?.data?.detail || "Eroare"); }
    finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" className="btn btn-secondary" data-testid={`purge-${entity}-${id}`}
        style={{ padding: "4px 10px", fontSize: 12, color: "#991B1B", borderColor: "#FCA5A5", ...style }} onClick={open}>
        Șterge definitiv
      </button>
      {info && createPortal(
        <Modal title="Ștergere definitivă" onClose={close} width={520}>
          {info.error ? <div style={{ color: "#991B1B", fontSize: 13 }}>{info.error}</div> : (
            <>
              <div style={{ fontSize: 14, marginBottom: 10 }}>Se șterge definitiv {info.what}: <b>{info.title}</b>.</div>
              {!info.can_delete ? (
                <div data-testid="purge-blocked" style={{ background: "#FEF2F2", border: "1px solid #FCA5A5", color: "#991B1B", borderRadius: 8, padding: "10px 14px", fontSize: 13 }}>
                  <b>Nu se poate șterge.</b>
                  <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
                    {info.blockers.map(b => <li key={b.label}>{b.count} {b.label}</li>)}
                    {info.rules.map(r => <li key={r}>{r}</li>)}
                  </ul>
                  {info.blockers.length > 0 && <div style={{ marginTop: 8 }}>Mută sau șterge mai întâi datele de mai sus. Între timp poți folosi „Dezactivează".</div>}
                </div>
              ) : (
                <>
                  <div style={{ background: "#FFFBEB", border: "1px solid #F59E0B", color: "#78350F", borderRadius: 8, padding: "10px 14px", fontSize: 13, marginBottom: 12 }}>
                    Nu are date legate și poate fi șters. <b>Operațiunea nu se poate anula</b>; se înscrie în Jurnalul de audit.
                  </div>
                  <label className="label">Scrie <b>șterge</b> pentru confirmare</label>
                  <input className="input" value={word} onChange={e => setWord(e.target.value)} data-testid="purge-confirm" autoFocus />
                  {err && <div style={{ color: "#991B1B", fontSize: 12, marginTop: 6 }}>{err}</div>}
                  <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 14 }}>
                    <button className="btn btn-secondary" onClick={close}>Anulează</button>
                    <button className="btn btn-danger" disabled={busy || word.trim().toLowerCase() !== "șterge"} onClick={doDelete} data-testid="purge-go">Șterge definitiv</button>
                  </div>
                </>
              )}
              {!info.can_delete && <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}><button className="btn btn-secondary" onClick={close}>Închide</button></div>}
            </>
          )}
        </Modal>, document.body)}
    </>
  );
}
